import React, { useState } from 'react'
import { ModalContainer, ModalContainerProps } from '@components/Modals/ModalContainer'
import { Box } from '@ui'

export const AboveAppProgressOverlay = () => {
    return <Box absoluteFill id="above-app-progress-root" pointerEvents="none" />
}

export const AboveAppProgressModalContainer = (props: ModalContainerProps) => {
    const [container] = useState(() => document.getElementById('above-app-progress-root'))

    if (!container) {
        return null
    }

    return (
        <ModalContainer rootLayer={container} sheetZIndex={0} {...props}>
            {props.children}
        </ModalContainer>
    )
}
